<template>
	<div class="dt-container">
		<img src="../../../assets/nigeria-coat-of-arms.png" class="coat-of-arm" />

		<h1 class="approved-stamp">Approved</h1>

		<div class="dt-header">
			<img src="../../../assets/nimasa-logo.png" style="padding: 1em" />
			<div>
				<h1 class="main-header">MANAGEMENT SYSTEM CERTIFICATE</h1>
				<p>Certificate No. {{ data.certificate_number }}</p>
				<br />
				<p><i>This is to certify that</i></p>
				<h2 class="name-tag">{{ data.shipper_name }}</h2>
				<p class="c-address">
					{{ data.shipper_address }}<br />
					has been found to confirm to the Quantity Management Sytem Standard
				</p>

				<p>
					this Certificate is valid for the following scope:
				</p>

				<p class="moveLeft">Items with UN Number(s):</p>

				<div class="table">
					<table>
						<thead>
							<tr>
								<th>UN Number</th>
								<th>Proper Shipping Name</th>
								<th>Gross Mass (kg)</th>
							</tr>
						</thead>

						<tbody v-for="item in data.dangerousGoods" :key="item.id">
							<tr>
								<td>{{ item.dangerous_good_info.un_number }}</td>
								<td>{{ item.chemical_name }}</td>
								<td>{{ item.dangerous_good_packaging[0].net_mass }}</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="certificate-listing">
					<div>
						<p><i>Initial certificate date</i></p>
						<h5>June 20th, 2019</h5>
					</div>
					<div></div>
					<div>
						<p><i>Signature</i></p>
						<h5>DG NIMASA</h5>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UpdateModal from "./UpdateModal.vue";
export default {
	name: "MainTable",
	components: { UpdateModal },
	props: {
		data: Object
	}
};
</script>
<style scoped>
* {
	padding: 0px;
	margin: 0px;
}
.moveLeft {
	text-align: left;
	font-weight: bold;
	width: 70%;
	margin: 5px auto;
}
.dt-container {
	text-align: center;
	width: 100%;
	margin: 0px auto;
	border: 1px solid black;
	font-family: arial;
	color: #3c5081;
	position: relative;
	margin-top: 40px;
	margin-bottom: 40px;
	overflow: hidden;
}
.main-header {
	font-size: 30px;
	font-weight: bolder;
}
.name-tag {
	font-size: 25px;
	font-weight: bolder;
}
.dt-container p {
	font-size: 14px;
}
.dt-container span {
	font-weight: bolder;
	font-size: 12px;
	color: grey;
	opacity: 0.8;
}
.c-address {
	font-weight: bold;
}
.dt-container h3 {
	padding: 20px;
	color: #3c5081;
	font-weight: bold;
}
.certificate-listing {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-column-gap: 20px;
	width: 80%;
	margin: 0px auto;
}
.certificate-listing div {
	padding: 10px;
	border-bottom: 1px solid black;
	margin-bottom: 20px;
}
.certificate-listing div {
	font-size: 12px;
	line-height: 15px;
}
.table {
	width: 70%;
	margin: 0px auto;
	border: 2px solid #3c5081;
	border-radius: 10px;
	margin-top: 10px;
	margin-bottom: 10px;
	color: black;
}
table {
	width: 100%;
	font-size: 14px;
	text-align: center;
}
table td {
	border-top: 1px solid #3c5081;
	padding: 12px;
	margin: 0px;
}
table th {
	padding: 12px;
	margin: 0px;
}
.approved-stamp {
	position: absolute;
	color: green;
	padding: 10px 40px;
	transform: rotate(-20deg);
	top: 180px;
	left: 30px;
	font-weight: bolder;
	border: 3px solid green;
	border-radius: 10px;
	font-size: 30px;
}
.coat-of-arm {
	width: 70%;
	position: absolute;
	top: 100px;
	left: 15%;
	z-index: -200;
	opacity: 0.05;
}
</style>
